module.exports = __webpack_public_path__ + "img/calendar2-date-fill.872cb4c4.svg";